import { render, staticRenderFns } from "./WebshopOrder.vue?vue&type=template&id=5ae692b1&"
import script from "./WebshopOrder.vue?vue&type=script&lang=js&"
export * from "./WebshopOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports